export enum BankInformationEnum {
  Value5700 = '5700',
  Value5701 = '5701',
  Value5702 = '5702',
}

export enum CaseBeneficiaryTypeEnum {
    BeneficialOwner = 2,
    PowerOfAttorney = 3,
    ParentalAuthority = 19,
    Owner = 20,
    JointAccountCombined = 30
}
